import * as THREE from 'three';

/**
 * The camera's opening pose: a three-quarter view onto the origin, used for
 * the first frame and as the fallback if nothing is on stage to frame.
 *
 * From the second frame on, `framing.js` drives it so that both fighters stay
 * in shot. Still no orbit controls, by design — the shipping game has a
 * directed camera, and a free one hides framing bugs instead of showing them.
 */
export const CAMERA_POSITION = Object.freeze({ x: 2.3, y: 1.75, z: 3.5 });
export const CAMERA_TARGET = Object.freeze({ x: 0, y: 0.95, z: 0 });

export function createCamera() {
  const camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    0.1,
    200
  );
  camera.position.set(CAMERA_POSITION.x, CAMERA_POSITION.y, CAMERA_POSITION.z);
  camera.lookAt(CAMERA_TARGET.x, CAMERA_TARGET.y, CAMERA_TARGET.z);
  return camera;
}
